import { useEffect } from 'react';

/**
 * Лёгкая обёртка над Fancybox для просмотра картинок в чате.
 *
 * - Грузим `@fancyapps/ui` лениво (динамический import) при первом
 *   монтировании компонента чата — чтобы пользователи без чатов не
 *   тащили эту библиотеку.
 * - Вешаем делегированный обработчик `Fancybox.bind(selector)`. Все
 *   ссылки `<a data-fancybox="..." href="…">` с подходящим именем
 *   галереи откроются в лайтбоксе. Новые сообщения, добавленные
 *   позже, тоже работают — Fancybox делегирует клик через document.
 * - При размонтировании отвязываем обработчик и закрываем открытый
 *   просмотр.
 *
 * @param {string} galleryName  имя группы (data-fancybox="…"), например 'chat-12'
 */
export function useChatLightbox(galleryName) {
  useEffect(() => {
    if (!galleryName) return;
    let cleanup = () => {};
    let cancelled = false;

    (async () => {
      const [{ Fancybox }] = await Promise.all([
        import('@fancyapps/ui'),
        import('@fancyapps/ui/dist/fancybox/fancybox.css'),
      ]);
      if (cancelled) return;
      const selector = `[data-fancybox="${galleryName}"]`;
      Fancybox.bind(selector, {
        // Не нужны кнопки thumbs/slideshow в чате — это просто фото.
        Thumbs: false,
        Toolbar: {
          display: { left: ['infobar'], middle: [], right: ['close'] },
        },
        Hash: false, // не мусорим хешем в URL
      });
      cleanup = () => {
        try { Fancybox.close(); } catch {}
        try { Fancybox.unbind(selector); } catch {}
      };
    })().catch((e) => {
      // Тихо проглатываем: при отсутствии Fancybox клик просто откроет
      // картинку в новой вкладке (см. href у ссылки).
      // eslint-disable-next-line no-console
      console.warn('Fancybox load failed:', e);
    });

    return () => {
      cancelled = true;
      cleanup();
    };
  }, [galleryName]);
}
